<template>
  <div class="mobile-plug">
    <div class="mobile-plug__info">
      <h2 class="mobile-plug__title">
        {{ $t('Continue on desktop') }}
      </h2>
      <p class="mobile-plug__text">
        {{ $t(`To use Fixtender, open`) }}
        <a href="https://app.fixtender.com" class="link">app.fixtender.com</a>
        {{ $t(`on your desktop and log in.`) }}
      </p>
    </div>
    <FixtenderDesktopIcon />
  </div>
</template>

<script>
  import FixtenderDesktopIcon from '@/assets/icons/fixtender-desktop.svg';

  export default {
    name: 'MobilePlug',
    components: {
      FixtenderDesktopIcon,
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .mobile-plug {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100000;
    background-color: white;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    > * + * {
      margin-top: 127px;
    }

    &__info {
      max-width: 335px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-align: center;
    }

    &__title {
      font-size: 28px;
      color: $grey900;
      font-weight: 700;
    }

    &__text {
      color: $grey600;
      font-weight: 400;
      font-size: 16px;
    }
  }
</style>
